import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import BottomBar from "../../layouts/bottomBar/BottomBar";
import NavbarMobile from "../../layouts/navabrMobile/NavbarMobile";
import Navbar from "../../layouts/navbar/Navbar";
import MobileSupport from "../../mobileView/support/MobileSupport";

const MobSupport = () => {
  // Mobile Responsive
  const [windowDimension, setWindowDimension] = useState(null);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;
  // Mobile Responsive

  return (
    <div>
      {isMobile ? <NavbarMobile /> : <Navbar />}
      <MobileSupport />
      {isMobile ? <BottomBar /> : ""}
    </div>
  );
};

export default MobSupport;
